import './Loader.css';

const Loader = () => {
    return (
        <div class="loader">
        <div class="big-circle">
          <div class="small-circle"></div>
        </div>
      </div>
       
    );
};

export default Loader;